onDomReady(() => {
   const navs = document.querySelectorAll('.js-page-navigation');
   if (navs.length) {
      ContentDropdownGroup(navs);
   }
});
